export default __webpack_public_path__ + "static/media/logo.138046ae.png";